import { Box } from "@mui/material";
import { useThemeColors } from "../context/ThemeContext";

// A frosted-glass surface — the building block of the modern UI. It is a
// semi-transparent panel with a backdrop blur that lets the ambient gradient
// blobs glow through, plus a soft shadow and an optional lift-on-hover.
//
// Props:
//   hover    — add the cursor + translateY lift + glow border on hover
//   accent   — hex colour for the thin top accent bar (omit for none)
//   sx       — extra MUI styles, merged last so callers can override
function GlassCard({ hover = false, accent, sx, children, ...rest }) {
  const colors = useThemeColors();

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        background: colors.glassBg,
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        border: `1px solid ${colors.glassBorder}`,
        borderRadius: 3,
        boxShadow: colors.shadowSm,
        transition: "transform 0.25s cubic-bezier(0.4,0,0.2,1), box-shadow 0.25s ease, border-color 0.25s ease",
        ...(accent && {
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "3px",
            background:
              typeof accent === "string" && accent.includes("gradient")
                ? accent
                : `linear-gradient(90deg, ${accent}, ${accent}00)`,
          },
        }),
        ...(hover && {
          cursor: "pointer",
          outline: "none",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: colors.shadowLg,
            borderColor: colors.glassBorderHover,
          },
          "&:focus-visible": {
            borderColor: "#818cf8",
            boxShadow: "0 0 0 3px rgba(129, 140, 248, 0.25)",
          },
        }),
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default GlassCard;
